<template>
  <b-container class="animated fadeIn px-0">
    <b-card class="default-card">
      <b-form ref="form0" class="needs-validation" novalidate @submit.prevent="form0OnSubmit()">
      <b-form-group
        horizontal
        label="2段階認証設定"
        label-size="lg"
        label-class="font-weight-bold pt-0"
      >
        <b-row>
          <b-col lg="3" xl="2">
            <b-form-group
              id="status"
              label="ステータス"
              class="mb-1"
              label-class="py-0 font-weight-bold"
            >
              <div>
                <b-badge v-show="twoFASettings.enabled" variant="success">有効</b-badge>
                <b-badge v-show="!twoFASettings.enabled" variant="danger">無効</b-badge>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="auth-method"
              label="認証方法"
              class="mb-1"
              label-class="py-0 font-weight-bold"
            >
              <b-form-radio-group v-show="!twoFASettings.enabled" v-model="twoFASettings.methodCd" class="mt-1"
                buttons button-variant="outline-primary"
              >
                <b-form-radio value="1">認証アプリ</b-form-radio>
                <b-form-radio value="2">メール</b-form-radio>
                <!-- <b-form-radio value="3">SMS</b-form-radio> -->
              </b-form-radio-group>
              <span v-show="twoFASettings.enabled">
                {{parseTwoFAMethod(twoFASettings.methodCd)}}
                <span v-show="twoFASettings.methodCd!=='1'">
                  : {{presentOTPSendTo}}
                </span><br/>
                （前回認証日時:&nbsp;
                <span v-if="twoFASettings.lastAuthTime">
                  {{ new Date(twoFASettings.lastAuthTime) | formatTime }}）
                </span>
                <span v-else>
                  - ）
                </span>
              </span>
            </b-form-group>

            <div v-show="!twoFASettings.enabled && twoFASettings.methodCd==='1'" class="mt-3">
              <h3 class="mb-1"><span class="badge badge-dark">事前準備</span></h3>
              お手持ちのスマートフォンに認証アプリをインストールしてください<br/>
              <small>※Google Authenticatorを推奨します</small><br/>
            </div>

            <b-form-group v-if="!twoFASettings.enabled && twoFASettings.methodCd==='2'" label="認証コード通知先メールアドレス" label-class="font-weight-bold" class="mt-3">
              <b-form-input type="email" inputmode="email" v-model="twoFASettings.otpSendTo" placeholder="email-address@example.co.jp"
                required maxlength="50" autocomplete="off" :disabled="isProcessing"
              />
              <b-form-invalid-feedback>
                メールアドレス（50文字以下）を入力してください
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="!twoFASettings.enabled && twoFASettings.methodCd==='3'" label="認証コード通知先携帯電話番号" label-class="font-weight-bold" class="mt-3">
              <b-form-input type="tel" inputmode="tel" v-model="twoFASettings.otpSendTo" placeholder="090xxxxxxxx"
                required maxlength="11" pattern="^0[7-9]0\d{7,8}$" autocomplete="off" :disabled="isProcessing"
              />
              <b-form-invalid-feedback>
                090, 080, 070 のいずれかで始まる携帯電話番号（10桁または11桁、ハイフンなし）を入力してください
              </b-form-invalid-feedback>
            </b-form-group>

          </b-col>
        </b-row>
      </b-form-group>

      <div class="float-right">
        <b-btn v-if="!twoFASettings.enabled" type="submit" variant="primary" size="lg" class="btn_exec">
          2段階認証有効化<b-spinner v-show="isProcessing" class="ml-1"/>
        </b-btn>
        <b-btn v-else variant="danger" size="lg" class="btn_exec" :class="{btn_exec_processing: isProcessing}" @click="btnDeactivateTwoFAOnClick">
          2段階認証無効化<b-spinner v-show="isProcessing" class="ml-1"/>
        </b-btn>
      </div>
    </b-form>
    </b-card>

    <!-- modals -->
    <b-modal ref="modalTwoFAActivation" class="modal-info" title="2段階認証有効化" ok-only ok-title="キャンセル" ok-variant="secondary" no-close-on-backdrop no-close-on-esc @hidden="modalTwoFAActivationOnHide()">
      <div v-if="twoFASettings.methodCd==='1'">
        <h3>認証方法: 認証アプリ</h3>
        認証コードを認証アプリから取得するための設定を行います<br/>
        <br/>
        <h2><span class="badge badge-dark">STEP1</span></h2>
        認証アプリにて下のQRコードを読み取ってください<br/>
        <img :src="qrCodeImage" width="30%"/><br/>
        <div>
          <span class="ml-1" id="secret">{{secret}}</span>&nbsp;
          <span  class="text-secondary" @click="copySecretToClipboard()"><font-awesome-icon v-show="secret" :icon="['fas', 'copy']" style="cursor: pointer;"/></span>&nbsp;
          <b-badge v-show="secretCopied" variant="secondary">コピー済み</b-badge><br/>
        </div>
        <br/>
        <strong>《QRコードを読み取れない、もしくは手動登録する場合》</strong><br/>
        QRコードの下に表示されている文字列（キー）をコピーして、認証アプリに貼り付けて登録してください<br/>
        <br/>
        <h2><span class="badge badge-dark">STEP2</span></h2>
        認証アプリに表示される6桁のコードを入力し、[認証]ボタンを押下してください<br/>
        <br/>
        <b-form id="form1" ref="form1" class="needs-validation" novalidate @submit.prevent="form1OnSubmit()">
          <b-form-group label="認証コード">
            <b-form-input id="passcode" v-model="passcode" type="text" inputmode="numeric" autocomplete="one-time-code" placeholder="123456"
              required maxlength="6" pattern="^\d{6}$" :disabled="isProcessing"/>
            <div class="invalid-feedback">
              認証コードは6桁の半角数字を入力してください
            </div>
            <b-btn type="submit" class="mt-1 float-right" variant="primary" :disabled="isProcessing">
              認証<b-spinner v-show="isProcessing" class="ml-1"/>
            </b-btn>
            <h3><span v-show="passcodeRejected" class="badge badge-danger">認証に失敗しました</span></h3>
          </b-form-group>
        </b-form>
      </div>

      <div v-if="twoFASettings.methodCd==='2'">
        <b-form id="form2" ref="form2" class="needs-validation" novalidate @submit.prevent="form2OnSubmit()">
          <h3>認証方法: メール</h3>
          認証コードをメールにて受け取るための設定を行います<br/>
          <br/>
          {{ twoFASettings.otpSendTo }}に通知された6桁のコードを入力し、[認証]ボタンを押下してください<br/>
          <small>※認証コードの通知に時間がかかる場合があります</small><br/>
          <br/>
          <b-form-group label="認証コード">
            <b-form-input id="passcode2" v-model="passcode" type="text" inputmode="numeric" autocomplete="one-time-code" placeholder="123456"
              required maxlength="6" pattern="^\d{6}$" :disabled="isProcessing"/>
            <b-form-invalid-feedback>
              認証コードは6桁の半角数字を入力してください
            </b-form-invalid-feedback>
            <b-btn type="submit" class="mt-1 float-right" variant="primary" :disabled="isProcessing">
              認証<b-spinner v-show="isProcessing" class="ml-1"/>
            </b-btn>
            <h3><span v-show="passcodeRejected" class="badge badge-danger">認証に失敗しました</span></h3>
          </b-form-group>
        </b-form>
      </div>

      <div v-if="twoFASettings.methodCd==='3'">
        <b-form id="form3" ref="form3" class="needs-validation" novalidate @submit.prevent="form3OnSubmit()">
          <h3>認証方法: SMS</h3>
          認証コードをSMS（ショートメッセージ）にて受け取るための設定を行います<br/>
          <br/>
          {{ twoFASettings.otpSendTo }}に通知された6桁のコードを入力し、[認証]ボタンを押下してください<br/>
          <small>※認証コードの通知に時間がかかる場合があります</small><br/>
          <br/>
          <b-form-group label="認証コード">
            <b-form-input id="passcode3" v-model="passcode" type="text" inputmode="numeric" autocomplete="one-time-code" placeholder="123456"
              required maxlength="6" pattern="^\d{6}$" :disabled="isProcessing"/>
            <b-form-invalid-feedback>
              認証コードは6桁の半角数字を入力してください
            </b-form-invalid-feedback>
            <b-btn type="submit" class="mt-1 float-right" variant="primary" :disabled="isProcessing">
              認証<b-spinner v-show="isProcessing" class="ml-1"/>
            </b-btn>
            <h3><span v-show="passcodeRejected" class="badge badge-danger">認証に失敗しました</span></h3>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

    <b-modal ref="modalActivated" header-bg-variant="primary" title="2段階認証有効化" @ok="linkToTop()" @hidden="linkToTop()" ok-only>
      2段階認証を有効化しました。
    </b-modal>
    <b-modal ref="modalDeactivateConfirm" header-bg-variant="danger" title="2段階認証無効化確認" @ok="deactivate()">
      2段階認証を無効化します。よろしいですか？
    </b-modal>
    <b-modal ref="modalDeactivated" header-bg-variant="primary" title="2段階認証無効化" @ok="linkToTop()" @hidden="linkToTop()" ok-only>
      2段階認証を無効化しました。
    </b-modal>
    <!-- /modals -->
  </b-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import API from "@/api/index"
import QRCode from 'qrcode'
import moment from 'moment'

const TWO_FA_METHOD = {
  '1': '認証アプリ',
  '2': 'メール',
  '3': 'SMS'
}
const TWO_FA_METHOD_CD = {
  AUTH_APP: '1',
  EMAIL: '2',
  SMS: '3'
}

export default {
  name: 'TwoFactorAuthentication',
  data () {
    return {
      isProcessing: false,
      tenantFeatures: {
        sms: { enabled: false }
      },
      twoFASettings: {
        enabled: false,
        methodCd: TWO_FA_METHOD_CD.AUTH_APP,
        otpSendTo: '',
        lastAuthTime: null
      },
      presentOTPSendTo: '', // 初期表示時点におけるOTP通知先（メールアドレスor携帯電話番号）
      otpauthUrl: '',
      secret: '',
      secretCopied: false,
      successfullySentPasscode: false,
      passcodeRejected: false,
      passcode: '',

      // ダイアログを多重に表示させない為のフラグ
      alreadyDialogDisplayed: false,
      // エラーダイアログの表示状態
      alreadyErrorDialogDisplayed: false,
    }
  },
  methods: {
    ...mapMutations("componentState", [
      'turnLoadingOn', 'turnLoadingOff'
    ]),
    ...mapActions('auth', ['logout']),
    async init() {
      this.turnLoadingOn()
      const params = {
        userId: this.userId
      }
      try {
        const ret = await API.setTwoFA.get(this.idToken(), {
          path: '?user_id=' + this.userId})

        const twoFASettings = ret.data.twoFASettings
        this.twoFASettings.enabled = twoFASettings.enabled
        this.twoFASettings.processing = twoFASettings.processing
        this.twoFASettings.email = twoFASettings.email
        if (twoFASettings.enabled) {
          this.twoFASettings.methodCd = twoFASettings.methodCd
          this.twoFASettings.lastAuthTime = twoFASettings.lastAuthTime
          this.presentOTPSendTo = twoFASettings.otpSendTo
        }
      } catch (error) {
        // レスポンスを持っているか
        if (!(error && error.hasOwnProperty('response'))) return
        // ステータスコードを持っているか
        if (!(error.response && error.response.hasOwnProperty('status'))) return
        if (error.response.status === 403)
          return this.$router.push({ path: '/session-timeout' })
        await this.showErrorDialog('二要素認証情報の取得に失敗しました。')
      } finally {
        this.turnLoadingOff()
      }
    },
    parseTwoFAMethod(cd) {
      return TWO_FA_METHOD[cd]
    },
    copySecretToClipboard() {
      var secret = document.getElementById('secret').innerText
      navigator.clipboard.writeText(secret)
      this.secretCopied = true
    },
    /**
     * 2段階認証有効化ボタン押下（またはサブミット）時
     */
    async form0OnSubmit() {
      if (this.$refs.form0.checkValidity()) {
        await this.prepareTwoFAActivation()
      }
    },
    async prepareTwoFAActivation() {
      this.turnLoadingOn()
      
      // 認証コード生成／検証に必要な情報を事前にDB登録・取得
      try {
        const ret0 = await API.setTwoFA.get(this.idToken(), {
          path: '?user_id=' + this.userId})

        const twoFASettings = ret0.data.twoFASettings
        this.twoFASettings.enabled = twoFASettings.enabled

        const params = {
          userId: + this.userId,
          twoFASettings: this.twoFASettings
        }
        
        const ret = await API.setTwoFA.post(this.idToken(), {
          data: params})

        if (this.twoFASettings.methodCd === TWO_FA_METHOD_CD.AUTH_APP) {
          this.otpauthUrl = ret.data.otpauthUrl
          this.secret = ret.data.secret
        }
        this.$refs.modalTwoFAActivation.show()
      } catch (error) {
        // レスポンスを持っているか
        if (!(error && error.hasOwnProperty('response'))) return
        // ステータスコードを持っているか
        if (!(error.response && error.response.hasOwnProperty('status'))) return
        if (error.response.status === 403)
          return this.$router.push({ path: '/session-timeout' })
        await this.showErrorDialog('二要素認証情報の有効化に失敗しました。')
      } finally {
        this.turnLoadingOff()
      }
    },
    /**
     * 2段階認証有効化ダイアログ キャンセルボタン押下（もしくはクローズ）時
     */
    modalTwoFAActivationOnHide() {
      // 入力値、処理ステータスをリセット
      this.secretCopied = false
      this.passcode = ''
      this.passcodeRejected = false
      this.successfullySentPasscode = false
      this.isProcessing = false
      this.$nextTick(() => {
        if (this.$refs.form0) this.$refs.form0.classList.remove('was-validated')
        if (this.$refs.form1) this.$refs.form1.classList.remove('was-validated')
        if (this.$refs.form2) this.$refs.form2.classList.remove('was-validated')
        if (this.$refs.form3) this.$refs.form3.classList.remove('was-validated')
      })
    },
    /**
     * 2段階認証有効化ダイアログ 認証ボタン押下時
     */
    async form1OnSubmit() {
      if (this.$refs.form1.checkValidity()) {
        await this.requestVerifyPasscode()
      }
    },
    async form2OnSubmit() {
      if (this.$refs.form2.checkValidity()) {
        await this.requestVerifyPasscode()
      }
    },
    async form3OnSubmit() {
      if (this.$refs.form3.checkValidity()) {
        await this.requestVerifyPasscode()
      }
    },
    async requestVerifyPasscode() {
      this.isProcessing = true
      this.passcodeRejected = false

      const params = {
        userId: + this.userId,
        methodCd: this.twoFASettings.methodCd,
        passcode: this.passcode
      }
      try {
        const ret = await API.activateTwoFA.post(this.idToken(), {
          data: params})
        switch(ret.data.returnCode) {
          case 0: // OK
            this.$refs.modalActivated.show()
            break
          case 2:
            this.passcodeRejected = true
            break
        }
      } catch (error) {
        // レスポンスを持っているか
        if (!(error && error.hasOwnProperty('response'))) return
        // ステータスコードを持っているか
        if (!(error.response && error.response.hasOwnProperty('status'))) return
        if (error.response.status === 403)
          return this.$router.push({ path: '/session-timeout' })
        await this.showErrorDialog('二要素認証情報の有効化に失敗しました。')
      } finally {
        this.isProcessing = false
        this.turnLoadingOff()
      }
    },
    /**
     * 2段階認証無効化ボタン押下時
     */
    btnDeactivateTwoFAOnClick() {
      this.$refs.modalDeactivateConfirm.show()
    },
    async deactivate() {
      this.isProcessing = true
      const params = {
        userId: + this.userId
      }
      try {
        await API.deactivateTwoFA.post(this.idToken(), {
          data: params})
        this.$refs.modalDeactivated.show()
      } catch (error) {
        // レスポンスを持っているか
        if (!(error && error.hasOwnProperty('response'))) return
        // ステータスコードを持っているか
        if (!(error.response && error.response.hasOwnProperty('status'))) return
        if (error.response.status === 403)
          return this.$router.push({ path: '/session-timeout' })
        await this.showErrorDialog('二要素認証情報の無効化に失敗しました。')
      } finally {
        this.isProcessing = false
        this.turnLoadingOff()
      }
    },
    linkToTop() {
      this.$router.push({path: '/'})
    },
    async linkToLogin() {
      await this.logout()
      this.$router.push('/login')    },
    async showErrorDialog(errorMessage) {
      this.alreadyDialogDisplayed = true
      // 既にエラーダイアログが表示されている場合は重ねて表示しない
      if (this.alreadyErrorDialogDisplayed === true) return
      this.alreadyErrorDialogDisplayed = true
      await this.$bvModal.msgBoxOk(
        `${errorMessage}`, this.errorDialogProps)
        .then(async () => {
        })
        .catch(() => {
          this.alreadyDialogDisplayed = false
          this.alreadyErrorDialogDisplayed = false
        })
      this.alreadyDialogDisplayed = false
      this.alreadyErrorDialogDisplayed = false
    }
  },
  
  computed: {
    ...mapGetters("auth", ['idToken', 'userId']),
    qrCodeImage() {
      let url = null
      QRCode.toDataURL(this.otpauthUrl, (err, src) => {
        url = src
      })
      return url
    },
    errorDialogProps() {
      return {
        title: 'エラー',
        headerBgVariant: 'danger',
        hideHeaderClose: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      }
    }
  },
  async created () {
    await this.init()
  },
  mounted() {
    const forms = document.getElementsByClassName('needs-validation')
    Array.prototype.filter.call(forms, form => {
      form.addEventListener('submit', event => {
        if (form.checkValidity() === false) {
          event.preventDefault()
          event.stopPropagation()
        }
        form.classList.add('was-validated')
      }, false)
    })
  },
  watch: {
    'twoFASettings.methodCd'() {
      this.$refs.form0.classList.remove('was-validated')
      this.twoFASettings.otpSendTo = ''
    }
  },
  filters: {
    formatTime(time) {
      return moment(time).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style scoped>
.form-spacer {
  margin-top: 6px;
}
.btn_exec {
  width: 200px;
  -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
  -moz-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
  -ms-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
  -o-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
}
.btn_exec_processing {
  width: 200px;
}
</style>
